export const MOBILE_CLOSE_MODAL_DELAY = 500;
